import axiosInstance from "../utils/axios"
// import { handleApiError } from "../utils/errorHandler"

export const userService = {
  fetchAll: async (params = {}) => {
    const response = await axiosInstance.get('/user/paginate', {
      params,
    })
    return response.data
  },
  getById: async (id) => {
    const response = await axiosInstance.get('/user/' + id)
    return response.data
  },
  getProfile: async () => {
    const response = await axiosInstance.get('/user/profile')
    return response.data
  },
  getMarketingByAB: async (ab) => {
    const response = await axiosInstance.post('/user/marketing-by-ab',{
      ab
    })
    return response.data
  },
  getAllSurveyor: async () => {
    const response = await axiosInstance.get(`/user/surveyor/all`)
    return response.data
  },
  getAllMarketing: async () => {
    const response = await axiosInstance.get(`/user/marketing/all`)
    return response.data
  },
  getSurveyor: async (ab) => {
    const response = await axiosInstance.get(`/user/surveyor?surveyor=${ab}`)
    return response.data
  },
  getSurveyorByMarketing: async () => {
    const response = await axiosInstance.get(`/user/surveyor-by-marketing`)
    return response.data
  },
  store: async (data) => {
    const response = await axiosInstance.post('/user', data)
    return response.data
  },
  changePassword: async (data) => {
    const response = await axiosInstance.post('/user/change-password', data)
    return response.data
  },
  update: async (data) => {
    const response = await axiosInstance.put(`/user/${data.id}`, data)
    return response.data
  },
  delete: async (id) => {
    const response = await axiosInstance.delete(`/user/${id}`)
    return response.data
  },
}